// extracted by css-extract-rspack-plugin
export default {"dataSourceSelectorWrapper":"jIvdoKO0yzE8uSOh","trigger":"X2hOVU674zsB5wHb","loadingDataSources":"tkc6QmRwzzM9fx90"};